module.exports = __webpack_public_path__ + "static/media/image4.cc38bd87.JPG";